import DefaultComponentLayout from './DefaultComponentLayout'
import LayoutContent from './LayoutContent'
import ErrorContent from './ErrorContent'

export {
  LayoutContent,
  ErrorContent,
}
export default DefaultComponentLayout
